export default __webpack_public_path__ + "static/media/refresh-circle.92edb088.svg";